const ZERO_ROADMAP_PATH = "ecologi-zero-roadmap";

export const isZeroRoadmap = (path?: string | string[]) => ZERO_ROADMAP_PATH === path;
